import { Permission } from "../../hooks";

export class User {
  constructor(
    readonly id: string,
    readonly displayName: string,
    readonly email: string,
    readonly createdAt: string,
    readonly permissions: readonly Permission[],
    readonly isAdUser: boolean,
    readonly initials?: string,
    readonly pictureUrl?: string
  ) {}

  hasAnyOf(...permissions: Permission[]): boolean;
  hasAnyOf(permissions: Permission | Permission[]): boolean;
  hasAnyOf(args: any): boolean {
    const permissions = args && Array.isArray(args) ? (args as Permission[]) : [args as Permission];
    return this.permissions?.some((p) => permissions.includes(p));
  }
}

export type CurrentUser = User | undefined;
